import { useEffect } from 'react';

function useKeyDown(handler) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      handler(event);
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handler]);
}

export default useKeyDown;
